<template>
  <router-view/>
</template>

<script setup>
import { ztclicklogin } from '@/port/pages/login'
import { useRouter } from 'vue-router'

const router = useRouter()
const search = window.location.search


const getZtLogin = async (st)=> {
  const res = await ztclicklogin({ticket: st}).catch(err => { console.log(err) })
  // console.log('查询ticket', res)
  if (res.code === 0) {
    const userMsg = res.data.userinfo
    userMsg.schoolMsg = userMsg.listschool[0]
    localStorage.setItem("userMsg", JSON.stringify(userMsg));
    localStorage.setItem("user", JSON.stringify(res.data.accesstoken));
    document.cookie = "accesstoken=" + res.data.accesstoken.accesstoken + ";path=/";
    document.title = userMsg.schoolMsg.name;
    router.replace({path: '/index'})
  } else {
    router.replace({path: '/'})
  }
}


if (search && search.substring(0, 8) === '?ztOpen=') {
  const st = search.substring(8, search.length)
  getZtLogin(st)
}

</script>

<style lang="scss">
// 滚动条整体部分
*::-webkit-scrollbar {
  width: 6px;
  height: 7px;
}
// 滚动条的轨道的两端按钮，允许通过点击微调小方块的位置。
*::-webkit-scrollbar-button {
  display: none;
}
// 滚动条的轨道（里面装有Thumb）
*::-webkit-scrollbar-track {
  background: transparent;
}
// 滚动条的轨道（里面装有Thumb）
*::-webkit-scrollbar-track-piece {
  background-color: transparent;
}
// 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条）
*::-webkit-scrollbar-thumb {
  background: rgba(144, 147, 153, 0.3);
  cursor: pointer;
  border-radius: 4px;
}
// 边角，即两个滚动条的交汇处
*::-webkit-scrollbar-corner {
  display: none;
}
// 两个滚动条的交汇处上用于通过拖动调整元素大小的小控件
*::-webkit-resizer {
  display: none;
}
</style>
